import React, { useState } from 'react';
import { TypographyStyledBlack } from '../../../../shared/components/tileLinkStyled/style';
import { Box, Container, Button, Modal } from '@mui/material';
import { BlueHeaderWithText } from '../../../estimatingRequirements/peng2018/blueHeaderWithText';
import { metaDataSelector } from '../../../../store/globalSelectors';
import { useAppSelector } from '../../../../store/hooks';
import { NavigationButtons } from '../../../../shared/components/navigationButtons';
import { Tooltip } from '../../../../shared/components/toolTip/';

import ScreeningResultsIcon from '../../../../assets/icons/screeningResultsIcon.svg';
import InfoIcon from '../../../../assets/icons/infoIcon.svg';

export const CalfCircumScreeningResult = () => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { muscleScreening, patientInformation } =
    useAppSelector(metaDataSelector);
  const { calfCircumference } = muscleScreening;
  const { gender } = patientInformation;

  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          width: '100%',
          backgroundColor: '#F2F2F2',
          p: 0,
          top: 0,
          left: 0
        }}
      >
        <Container
          sx={{
            display: 'flex',
            flexDirection: 'row',
            padding: '0px',
            justifyContent: 'flex-end',
            margin: '0px'
          }}
        >
          <Button
            onClick={handleOpen}
            sx={{
              height: '1.25rem',
              minWidth: '1.25rem',
              padding: '0px',
              marginTop: '1.875rem'
            }}
          >
            <img src={InfoIcon} alt={'Info'} />
          </Button>
        </Container>

        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column'
          }}
        >
          <Box
            sx={{
              backgroundColor: '#fff',
              height: '100px',
              width: '100px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <img alt="Screening Result Icon" src={ScreeningResultsIcon} />
          </Box>

          <TypographyStyledBlack sx={{ margin: '3.125rem 0' }}>
            SCREENING RESULTS
          </TypographyStyledBlack>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%'
            }}
          >
            <BlueHeaderWithText
              text1={'Calf circumference (cm):'}
              value1={String(calfCircumference.calculatedCircumference)}
              single={true}
              customWidth="90%"
            />
          </Box>
        </Box>

        {gender.toLowerCase() === 'male' &&
          calfCircumference.calculatedCircumference < 34 && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '1.875rem'
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  width: '80%',
                  backgroundColor: '#fff',
                  border: '0.125rem solid #002A3A',
                  borderRadius: '0.9375rem',
                  padding: '0.9375rem'
                }}
              >
                {`Calf circumference suggests `}
                <strong>low muscle mass.</strong>
              </Box>
            </Box>
          )}

        {gender.toLowerCase() === 'male' &&
          calfCircumference.calculatedCircumference >= 34 && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '1.875rem'
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  width: '80%',
                  backgroundColor: '#fff',
                  border: '0.125rem solid #002A3A',
                  borderRadius: '0.9375rem',
                  padding: '0.9375rem'
                }}
              >
                {`Calf circumference does not suggest `}
                <strong>low muscle mass.</strong>
              </Box>
            </Box>
          )}

        {gender.toLowerCase() === 'female' &&
          calfCircumference.calculatedCircumference < 33 && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '1.875rem'
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  width: '80%',
                  backgroundColor: '#fff',
                  border: '0.125rem solid #002A3A',
                  borderRadius: '0.9375rem',
                  padding: '0.9375rem'
                }}
              >
                {`Calf circumference suggests `}
                <strong>low muscle mass.</strong>
              </Box>
            </Box>
          )}

        {gender.toLowerCase() === 'female' &&
          calfCircumference.calculatedCircumference >= 33 && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '1.875rem'
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  width: '80%',
                  backgroundColor: '#fff',
                  border: '0.125rem solid #002A3A',
                  borderRadius: '0.9375rem',
                  padding: '0.9375rem'
                }}
              >
                {`Calf circumference does not suggest `}
                <strong>low muscle mass.</strong>
              </Box>
            </Box>
          )}
      </Box>

      <NavigationButtons nextRoute={'/summary'} nextDisabled={false} />

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Tooltip
          onClose={handleClose}
          title={'Reference:'}
          content={`Gonzalez CM et al. Am J Clin Nutri. 2021;113:1679-1687
Prado C et al. Clin Nutri. 2022;41:2244-2263.
Ishida Y et al. Geriatr. Gerontol. Int. 2019;19:993-998.`}
        />
      </Modal>
    </>
  );
};
